import { ChangeRoleModalTranslations } from "./types";

export const deTranslations: ChangeRoleModalTranslations = {
    title: "Rolle ändern",
    options: {
        Teacher: "Lehrer",
        Admin: "Admin",
    },
    submit: "Absenden",
};
